import { render } from "./Comment.vue?vue&type=template&id=ba8486f0&scoped=true"
import script from "./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue?vue&type=script&lang=js"

import "./Comment.vue?vue&type=style&index=0&id=ba8486f0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ba8486f0"

export default script